// import deepExtend from './../utilities/deepExtend.js';
import closestParent from './../utilities/closestParent.js';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const ios = document.documentElement.classList.contains('ios');

export default function ScrollTo() {
  return {
    init: () => {
      document.addEventListener('click', (event) => {
        const target = closestParent(
          event.target,
          'a[href^="#"]:not([href="#"]):not([data-w-noscrollto]):not([class*="w-js-trigger-level-"])'
        );
        if (target) {
          event.preventDefault();

          // remove open menu in any case
          // document.documentElement.classList.remove(
          //     'w-has-menu-open'
          // );
          // const closeMenuEvent = new CustomEvent(
          //     'w.FixedMenuHandler.close'
          // );
          // document.dispatchEvent(closeMenuEvent);

          let scrollTarget = document.querySelector(
            target.getAttribute('href')
          );
          if (scrollTarget.querySelector('[data-w-scrollto-anchor]'))
            scrollTarget = scrollTarget.querySelector(
              '[data-w-scrollto-anchor]'
            );
          if (scrollTarget) {
            console.log(ios);
            if (ios) {
              scrollTarget.scrollIntoView({
                behavior: 'smooth',
              });
            } else {
              gsap.to(window, {
                duration: 1,
                scrollTo: {
                  y: scrollTarget,
                  // offsetY: window.innerHeight / 2,
                  autoKill: true,
                },
                ease: 'power2',
              });
            }
          }
        }
      });
    },
  };
}
